import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/context/LanguageContext";
import { carDetailsLabels } from "@/i18n";

interface GuestLoginPromptProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const GuestLoginPrompt = ({
  open,
  onOpenChange,
}: GuestLoginPromptProps) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const labels = carDetailsLabels(language).guest;

  const redirectTarget =
    typeof window !== "undefined"
      ? `${window.location.pathname}${window.location.search}${window.location.hash}`
      : "/auctions";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{labels.loginTitle}</DialogTitle>
          <DialogDescription>{labels.loginDescription}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {labels.cancel}
          </Button>
          <Button
            onClick={() => {
              onOpenChange(false);
              navigate(`/auth?redirect=${encodeURIComponent(redirectTarget)}`);
            }}
          >
            {labels.loginCta}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
